import React, { useState, useCallback } from 'react'
import { useQuery } from '@apollo/client'
import { debounce } from 'lodash'
import { SEARCH_EMPLOYEES } from '../infra/queries'
import SearchView from '../presentation/SearchView'
import ResultsView from '../presentation/ResultsView'
import { LoadingSpinner } from '../presentation/spinners'

const IndexContainer = () => {
  const [searchText, setSearchText] = useState('')
  const [debouncedText, setDebouncedText] = useState('')

  // eslint-disable-next-line
  const debounceSearchText = useCallback(debounce(name => setDebouncedText(name), 500), [])

  const handleChangeSearchText = text => {
    setSearchText(text)
    debounceSearchText(text)
  }

  return (
    <>
      <SearchView searchText={searchText} onChangeSearchText={handleChangeSearchText} />
      {debouncedText.length > 2 ? <ResultsContainer text={debouncedText} /> : null}
    </>
  )
}

const ResultsContainer = ({ text }) => {
  const { loading, error, data } = useQuery(SEARCH_EMPLOYEES, { variables: { text } })

  if (loading) return <LoadingSpinner />
  if (error) throw error

  return <ResultsView employees={data.searchEmployees} />
}

export default IndexContainer
